import { LitElement, html, css } from 'lit-element';

import { DETAIL_MODES } from './constants';
export class FormElement extends LitElement {
    constructor() {
        super();
        this.detailMode = DETAIL_MODES.VIEW;
    }

    static get styles() {
        return [
            css`
                :host {
                    display: flex;
                    flex-flow: column;
                    flex: 1;
                }
                tmn-select {
                    max-width: 200px;
                }
                tmn-input {
                    max-width: 350px;
                }
                tmn-checkbox {
                    width: fit-content;
                }
                tmn-form-group label {
                    font-weight: 600;
                }
                tmn-form-group {
                    user-select: unset;
                }
                tmn-form-group[row] {
                    align-items: center;
                }

                tmn-form-group span {
                    /* border-bottom: 1px solid #422f2f; */
                    padding: 4px 0px;
                    padding-bottom: 4px;
                    margin-bottom: 4px;
                    font-weight: 400;
                }
                tmn-form-group tmn-icon {
                    margin-left: 0px;
                    margin-right: 6px;
                }
                tmn-form-group .tmn-icon-placeholder {
                    height: 22px;
                    padding: 0;
                    margin-right: 6px;
                    width: 22px;
                    display: inline-flex;
                }
                tmn-icon[icon='check_circle_outline'] {
                    color: var(--app-success-color);
                }
                tmn-icon-button[name='domain-check'] {
                    padding-bottom: 5px;
                }
                .custom-err {
                    border: 1px solid var(--app-error-color);
                    font-size: 0.75rem;
                    padding: 6px;
                    margin-bottom: 6px;
                    color: var(--app-error-color);
                }
            `,
        ];
    }

    static get properties() {
        return {
            itemTemplate: {
                type: Object,
            },
            path: {
                type: String,
            },
            // note false here doesn't mean invalid
            // it just means current value isn't known to have passed validation
            // open to better names
            hasPassedValidationCheck: {
                type: Boolean,
            },
            validationError: {
                type: String,
            },
            detailMode: {
                type: String,
            },
            isReadOnly: {
                type: Boolean,
            },
            isOverrideMode: {
                type: Boolean,
            },
            hasOverrideValue: {
                type: Boolean,
            },
            isDirty: {
                type: Boolean,
            },
            value: {
                // maybe override in derived classes?
                type: Object,
            },
            actions: {
                type: Object,
            },
        };
    }

    render() {
        // overrite in derived class
        return null;
    }

    getKey() {
        const { path } = this;
        if (!path) {
            return;
        }
        return path.split('.').pop();
    }

    getDisplayLabel() {
        const { itemTemplate } = this;
        return itemTemplate?.displayKey || this.getKey();
    }

    isViewMode() {
        const { detailMode } = this;
        return detailMode === DETAIL_MODES.VIEW;
    }

    isAddNewMode() {
        const { detailMode } = this;
        return detailMode === DETAIL_MODES.NEW;
    }

    isEditMode() {
        const { detailMode } = this;
        return detailMode === DETAIL_MODES.EDIT;
    }

    renderCustomError(msg) {
        if (msg) {
            return html`<div class="custom-err">${msg}</div>`;
        }
    }
}
